<template>
  <div v-if="loading">
    
  </div>
  <div v-else>

    <v-btn
      outlined
      class="text-none mb-4 pl-3 pr-3"
      color="gray12Color"
      style="background: var(--v-whiteColor-base);"
      @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy`)"
    >
      <i class="material-icons-outlined mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">arrow_back</i> <span style="color: var(--v-blackColor-base);">Back to Keyword Strategy</span>
    </v-btn>
    
    <div v-if="report">
        
      <div>
        <div class="mb-2" style="color: var(--v-gray50Color-base); font-size: 1rem;">{{ site.name }}</div>
        
        <div class="d-flex align-center justify-space-between gap10 mb-4">
          <div class="card-big-title" style="color: var(--v-blackColor-base); font-weight: 700; font-size: 1.5rem;">
            1-click silo results
            <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
              @click="() => {
                $store.commit('setCurrentVideoTutorialToDisplay', {
                  title: 'Build a Full SEO Content Silo in 1 Click (No Guesswork)',
                  videoLink: 'https://www.youtube.com/embed/2s9stk-kkac',
                  description: 'In this video, Heather Cumins, Customer Success Manager at PageOptimizer Pro, walks you through how to build a complete, ready-to-publish SEO content plan - in just one click.',
                  time: '3m 53s'
                });
              }">
              videocam
            </span>
          </div>

          <div class="d-flex align-center gap10">
            <b-dropdown aria-role="list" position="is-bottom-left">
              <template #trigger>
                <v-btn
                  outlined
                  class="text-none"
                  color="gray12Color"
                  style="background: var(--v-whiteColor-base);"
                >
                  <i class="material-icons mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">school</i> <span style="color: var(--v-blackColor-base);">Working with results</span>
                </v-btn>
              </template>
    
              <b-dropdown-item custom style="width: 1000px;">
                <working-with-results-part />
              </b-dropdown-item>
            </b-dropdown>
  
            <v-btn
              outlined
              class="text-none"
              color="gray12Color"
              style="background: var(--v-whiteColor-base);"
              href="https://help.pageoptimizer.pro/article/difference-between-top-level-and-supporting-content-keywords"
              target="_blank"
            >
              <i class="material-icons mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">school</i> <span style="color: var(--v-blackColor-base);">How to use this dashboard?</span>
            </v-btn>
          </div>
          
        </div>
        
      </div>
        
      <div v-if="topic">

        <div
          v-if="currentAsyncTask?.is_pending_or_in_progress"
          class="d-flex flex-column align-center pt-8 pb-8"
        >
          <div class="d-flex flex-column align-center" style="max-width: 500px; text-align: center;">
            <img src="/static/keyword-insight-processing-image.svg" width="315" height="222" class="mb-4" />
            <div class="mb-6" style="font-size: 1.2rem; font-weight: bold; line-height: 1.6; max-width: 400px;">Hang tight! Your silo’s on the way - this can take up to 7 minutes…</div>
      
            <v-progress-linear
              class="mb-4" 
              style="max-width: 300px;"
              rounded height="5"
              color="profileAnchorColor"
              :value="currentAsyncTask.task_status.value || 0">
            </v-progress-linear>
  
            <div style="font-size: 1rem; color: var(--v-gray50Color-base);">{{ currentAsyncTask.task_status.status === 'PENDING' ? 'Starting...' : currentAsyncTask.task_status.msg }}</div>
          </div>  
        </div>
  
        <keyword-research-result
          v-else
          title="1-Click Silo"
          reportType="SiloResearchTopic"
          siloResearchType="one-click-silo"
          :report="topic"
          :parentReport="report"
          :researchHistory="[]"
          :hasUnlimitedAccess="hasUnlimitedAccess"
  
          @refreshReport="() => loadReport()"
          @onAIResultReady="() => loadReport()"
          @onKeywordLabelUpdateSuccess="onKeywordLabelUpdateSuccess"
        />

      </div>
      

    </div>

    <div v-else>
      <div class="card-big-title mb-8 d-flex gap10">
        No report found
      </div>
    </div>

  </div>
</template>

<script>
import KeywordResearchResult from '@/components/Campaigns/KeywordResearchResult.vue';
import WorkingWithResultsPart from './WorkingWithResultsPart.vue';
import rockyKeywordScreenMixin, {
  KEYWORD_SCREENS,
  short as rockyShort,
} from '../../../rockyKeywordScreen.js';


export default {
  mixins: [rockyKeywordScreenMixin],
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    KeywordResearchResult,
    WorkingWithResultsPart
  },
  data () {
    return {
      loading: true,
      report: null,
      topic: null,
    }
  },
  computed: {
    asyncTasks() {
      return this.$store.state.asyncTasks
    },
    currentAsyncTask() {
      return this.asyncTasks.filter(task => task.type.startsWith('SiloResearch.one_click_silo_task') && task.record_id === this.report?.id)[0]
    },
  },
  watch: {
    // Rocky's refresh signal (PopAssistantButton.handleRefresh). A research
    // POP Pilot started through the API is not in the store's task list, so
    // currentAsyncTask never flips here; reload the report when asked.
    '$store.state.triggerRockyRefresh': function () {
      this.loadReport()
    },
    currentAsyncTask: function (newVal, oldVal) {
      if (newVal?.is_completed && oldVal && newVal?.is_completed !== oldVal?.is_completed) {
        this.reloadUser()
        this.loadReport()
      }
      this.emitRockyKeywordScreenDebounced()
    }
  },
  methods: {
    // Rocky snapshot for the states the results table doesn't cover: loading,
    // generating (async task running) and missing report. When the
    // KeywordResearchResult child is rendered, it emits the ready snapshot
    // itself — return null so this parent stays silent.
    buildRockyScreenData () {
      const generating = !!this.currentAsyncTask?.is_pending_or_in_progress
      if (!this.loading && this.report && this.topic && !generating) return null
      let status = 'loading'
      if (!this.loading) {
        status = generating ? 'generating' : (this.report ? 'loading' : 'empty')
      }
      return {
        screen: KEYWORD_SCREENS.STRATEGY_RESULTS,
        status,
        loading: this.loading || generating,
        recordIds: { siloResearchId: this.$route.params.id },
        data: {
          progressPct: this.currentAsyncTask?.task_status?.value ?? null,
          progressMsg: rockyShort(this.currentAsyncTask?.task_status?.msg),
        },
      }
    },
    loadReport () {
      return this.$store.dispatch('siloResearchSingle', {
        id: this.$route.params.id,
        includeTopics: 1,
        includeKeywords: 1,
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.report = response.data.research
          this.topic = response.data.research?.topics?.[0]
        }
      })
    },
    onKeywordLabelUpdateSuccess(keywords, label, resetExistingTopLevelKeywords) {
      this.topic = {
        ...this.topic,
        result: this.topic.result.map((row) => {
          if (label === 'T' && row.isTopLevelKeyword && resetExistingTopLevelKeywords) {
            return {
              ...row,
              isTopLevelKeyword: false,
              isSecondaryKeyword: false
            }
          }
          if (keywords.includes(row.keyword)) {
            return {
              ...row,
              isTopLevelKeyword: label === 'T' || label === 'ST',
              isSecondaryKeyword: label === 'ST',
              isSupportingKeyword: label === 'S',
            }
          }
          return row
        })
      }
    },
  },
  mounted () {
    this.emitRockyKeywordScreen()
    this.loadReport()
    .finally(() => {
      this.loading = false
      this.emitRockyKeywordScreen()
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./../../styles.scss";
</style>